<div class='m-4 font-weight-bold'><span class="text-info">DD/MM/YY</span><span> - NAME OF DASHBOARD</span></div>
<div class='m-4 d-flex flex-wrap'>
    <ng-content></ng-content>
</div>